import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './main/main.component';
import { MsalGuard } from '@azure/msal-angular';
import { APP_INITIALIZER } from '@angular/core';
import { PreloadAllModules } from '@angular/router';

import { PermissionsService } from './app-permission.service';

import { ADJUSTMENT_FEATURE_KEY } from './adjustment/adjustment-routing.module';
import { BENEFIT_FEATURE_KEY } from './benefit/benefit-routing.module';
import { ITEMCATEGORY_FEATURE_KEY } from './item-category/item-category-routing.module';
import { ITEM_FEATURE_KEY } from './items/item-routing.module';
import { OWNER_FEATURE_KEY } from './owners/owner-routing.module';
import { OWNER_LOCATION_FEATURE_KEY } from './owners-locations/owner-location-routing.module';
import { PACKING_FEATURE_KEY } from './packing/packing-routing.module';
import { PICKING_FEATURE_KEY } from './picking/picking-routing.module';
import { PROFILE_FEATURE_KEY } from './profiles/profiles-routing.module';
import { PURCHASE_ORDER_FEATURE_KEY } from './purchase-order/purchase-order-routing.module';
import { SALES_ORDER_FEATURE_KEY } from './sales-order/sales-order-routing.module';
import { SECURITY_FEATURE_KEY } from './security/security-routing.module';
import { SHIPMENT_FEATURE_KEY } from './shipment/shipment-routing.module';
import { TRANSFER_FEATURE_KEY } from './transfer/transfer-routing.module';
import { OWNER_LOCATION_ITEMS_FEATURE_KEY } from './owners-location-items/owner-location-items-routing.module';

export function loadPerms(perms: PermissionsService) {
  return () => perms.init();
}

const routes: Routes = [
  {
    path: '', component: MainComponent, pathMatch: 'full',
    title: 'Home',
    canActivate: [MsalGuard]
  },
  {
    path: SECURITY_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./security/security-routing.module').then(m => m.SecurityRoutingModule)
  },
  {
    path: OWNER_FEATURE_KEY,
    canActivate: [MsalGuard], 
    loadChildren: () => import('./owners/owner-routing.module').then(m => m.OwnerRoutingModule)
  },
  {
    path: OWNER_LOCATION_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./owners-locations/owner-location-routing.module').then(m => m.OwnerLocationRoutingModule)
  },
  {
    path: PROFILE_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./profiles/profiles-routing.module').then(m => m.ProfileRoutingModule)
  },
  {
    path: ITEM_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./items/item-routing.module').then(m => m.ItemRoutingModule)
  },
  {
    path: PURCHASE_ORDER_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./purchase-order/purchase-order-routing.module').then(m => m.PurchaseOrderRoutingModule)
  },
  {
    path: SALES_ORDER_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./sales-order/sales-order-routing.module').then(m => m.SalesOrderRoutingModule)
  },
  {
    path: PICKING_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./picking/picking-routing.module').then(m => m.PickingRoutingModule)
  },
  {
    path: PACKING_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./packing/packing-routing.module').then(m => m.PackingRoutingModule)
  },
  {
    path: SHIPMENT_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./shipment/shipment-routing.module').then(m => m.ShipmentRoutingModule)
  },
  {
    path: OWNER_LOCATION_ITEMS_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./owners-location-items/owner-location-items-routing.module').then(m => m.OwnerLocationItemsRoutingModule)
  },
  {
    path: TRANSFER_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./transfer/transfer-routing.module').then(m => m.TransferRoutingModule)
  },
  {
    path: BENEFIT_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./benefit/benefit-routing.module').then(m => m.BenefitRoutingModule)
  },
  {
    path: ITEMCATEGORY_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./item-category/item-category-routing.module').then(m => m.ItemCategoryRoutingModule)
  },
  {
    path: ADJUSTMENT_FEATURE_KEY,
    canActivate: [MsalGuard],
    loadChildren: () => import('./adjustment/adjustment-routing.module').then(m => m.AdjustmentRoutingModule)
  },
  // where the guard redirects on denied access
  { path: 'not-authorized', loadComponent: () => import('./shared/components/not-authorized/not-authorized.component').then(m => m.NotAuthorizedComponent) },
  // Fallback
  { path: '**', redirectTo: 'not-authorized' }
]

@NgModule({
  declarations: [
  ],
  providers: [
    { provide: APP_INITIALIZER, useFactory: loadPerms, deps: [PermissionsService], multi: true }
  ],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
